import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class FeedbackStudentsPreviewMetaModel extends FormMetaModel {
    constructor() {
        super('Feedback Student Preview', ROUTE_PATH.feedbackMappinggrid, ROUTE_PATH.feedbackStudentsPreview, 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();


        const buttons = {
            close: new SmBtnMetaModel('Submit', '', true, false, true, true,false),
            isFormControl: false
        };

        const closeBtn = {
            closeBtn: new SmBtnMetaModel('Close', '', true, false, true, true,false),
            isFormControl: false
        }

        return {
            formInfo,
            buttons,
            closeBtn
        }
    }
}